declare var chrome: any;

export const isExtension = typeof chrome !== "undefined" && chrome.runtime;
